import React from 'react'
import { GET_FEATURED_IMAGE } from '../helpers/constants'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <div data-type='block-wrapper'>
      <div data-type='block'>
        <div data-type='block-image'>
          <picture data-type='image'>
            <img
              width='502'
              height='501'
              itemProp='image'
              src={GET_FEATURED_IMAGE}
              alt='hero'
              role='presentation'
              data-type='image'
            />
          </picture>
        </div>
        <div data-type='block-text' data-style='second-item'>
          <p data-type='block-title'>Get Featured by Saatchi Art</p>
          <p data-type='block-sub-text'>
            We are invested into giving you as much exposure as possible. These are just some of the
            ways we promote our artists every day:
          </p>
          <ul data-type='block-list'>
            <li>Attention from our expert curators who review all artworks uploaded daily</li>
            <li>
              Art Advisors make recommendations and facilitate sales to private collectors in over
              140 countries
            </li>
            <li>
              Reach new collectors around the world via direct mail catalogs, digital marketing,
              social media advertising, and more
            </li>
            <li>
              Dedicated team of art consultants working to source artwork for commercial partners
              around the globe
            </li>
            <li>
              Rich editorial initiatives and content features including Rising Stars, New this Week,
              Digital Exhibitions and Curated Collections
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default Component